import React, { memo, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Switch from '@material-ui/core/Switch'
import { makeStyles } from '@material-ui/core/styles'
import { withTheme } from 'styled-components'
import { ReactComponent as InfoOutline } from 'images/information-outline.svg'
import Tooltip from 'components/Tooltip'

const useStyles = (vstTheme) =>
  makeStyles((theme) => ({
    root: {
      padding: '5px',
    },
    thumb: {
      backgroundColor: '#ffffff',
      border: '1px solid #868686',
    },
    track: {
      borderRadius: '100px',
      backgroundColor: '#ECECEC !important',
      border: '1px solid #919191',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {
      '& + $track': {
        backgroundColor: `${vstTheme.vstui.color.primary.getShade(6)} !important`,
        opacity: '1 !important',
        border: 'none',
      },
      '& $thumb': {
        border: 'none',
      },
    },
  }))()

const AllowLateWorkSwitch = ({ onAllowLateWork, lateWorkAllowed, theme }) => {
  const [isLateWorkAllowed, setIsLateWorkAllowed] = useState(lateWorkAllowed)
  const { t } = useTranslation()
  const classes = useStyles(theme)
  const tooltipTitle = t('allowLateWorkSwitch.lateWorkTooltip')

  const onSwitch = (e) => {
    setIsLateWorkAllowed(e.target.checked)
    onAllowLateWork(e.target.checked)
  }

  return (
    <div className="allow-late-work-switch">
      <Tooltip title={tooltipTitle}>
        <span className="label">
          <InfoOutline className="info-icon" />
          {t('allowLateWorkSwitch.allowLateWork')}
        </span>
      </Tooltip>
      <Switch
        onClick={onSwitch}
        checked={isLateWorkAllowed}
        classes={{
          root: classes.root,
          track: classes.track,
          thumb: classes.thumb,
          checked: classes.checked,
        }}
      />
    </div>
  )
}

export default memo(withTheme(AllowLateWorkSwitch))

AllowLateWorkSwitch.propTypes = {
  /**
   * Theme object used for style customization.
   */
  theme: PropTypes.object,
  /**
   * Allow late work function
   */
  onAllowLateWork: PropTypes.func,
  /**
   * Allow late work function
   */
  lateWorkAllowed: PropTypes.bool,
}

AllowLateWorkSwitch.defaultProps = {
  theme: {},
  onAllowLateWork: () => {},
  lateWorkAllowed: false,
}
